import React from "react";
import { ChevronLeft, ChevronRight, SearchX, RefreshCw } from "lucide-react";

import DoctorCard from "./DoctorCard";

export function DoctorListResults({
  loading,
  doctors,
  onClear,
  onReport,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  hasSearched = false,
}) {
  if (loading) {
    return (
      <div id="doctor-results" className="scroll-mt-28">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-[420px] rounded-3xl bg-white animate-pulse border border-slate-100"
            />
          ))}
        </div>
      </div>
    );
  }

  if (!hasSearched) {
    return (
      <div
        id="doctor-results"
        className="scroll-mt-28 bg-white rounded-[2rem] border border-slate-100 shadow-sm p-10 text-center"
      >
        <div className="mx-auto w-16 h-16 rounded-2xl bg-[#EEF4FF] flex items-center justify-center">
          <SearchX className="w-8 h-8 text-[#356DFF]" />
        </div>

        <h3 className="mt-5 text-2xl font-bold text-slate-900">
          Start your search
        </h3>

        <p className="mt-3 text-slate-500 max-w-xl mx-auto">
          Select a provider category, city, and availability status, then click
          Apply Filters to view matching providers.
        </p>
      </div>
    );
  }

  if (!doctors?.length) {
    return (
      <div
        id="doctor-results"
        className="scroll-mt-28 bg-white rounded-[2rem] border border-slate-100 shadow-sm p-10 text-center"
      >
        <div className="mx-auto w-16 h-16 rounded-2xl bg-[#EEF4FF] flex items-center justify-center">
          <SearchX className="w-8 h-8 text-[#356DFF]" />
        </div>

        <h3 className="mt-5 text-2xl font-bold text-slate-900">
          No providers found
        </h3>

        <p className="mt-3 text-slate-500 max-w-xl mx-auto">
          Try changing the provider category, city, or availability filters.
        </p>

        <button
          onClick={onClear}
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#356DFF] to-[#5B8CFF] px-6 py-3 text-sm font-semibold text-white shadow-lg"
        >
          <RefreshCw className="w-4 h-4" />
          Reset Filters
        </button>
      </div>
    );
  }

  return (
    <div id="doctor-results" className="scroll-mt-28">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {doctors.map((doctor) => (
          <DoctorCard key={doctor.id} doctor={doctor} onReport={onReport} />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="mt-12 flex items-center justify-center gap-2 flex-wrap">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="h-11 px-4 rounded-2xl border border-slate-200 bg-white text-slate-700 font-medium shadow-sm hover:shadow-md transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <ChevronLeft size={18} />
            Previous
          </button>

          {Array.from({ length: totalPages }).map((_, index) => {
            const page = index + 1;
            const active = currentPage === page;

            return (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={`h-11 w-11 rounded-2xl text-sm font-semibold transition-all ${
                  active
                    ? "bg-gradient-to-r from-[#356DFF] to-[#5B8CFF] text-white shadow-lg shadow-blue-200"
                    : "bg-white border border-slate-200 text-slate-700 hover:shadow-md"
                }`}
              >
                {page}
              </button>
            );
          })}

          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="h-11 px-4 rounded-2xl border border-slate-200 bg-white text-slate-700 font-medium shadow-sm hover:shadow-md transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2"
          >
            Next
            <ChevronRight size={18} />
          </button>
        </div>
      )}
    </div>
  );
}

export default DoctorListResults;